import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { GaTrackingEventCategory, GaTrackingEventName } from '~shared/modules/ga-tracking/constants';

export class BlockedVatIdsEvent implements ApplicationEvent {
  type = ApplicationEventType.Authorization;
  event = GaTrackingEventName.Errors;
  category = GaTrackingEventCategory.Errors;

  constructor(private action: string, private label: string) {}

  getPayload(): any {
    return {
      type: this.type,
      event: this.event,
      category: this.category,
      label: this.label,
      action: this.action,
      gtmCustom: {
        category: this.category,
      },
    };
  }
}
